import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import configurationReducer from './configuration';
import shiftsReducer from './shifts';
import modelsReducer from './models';
import maintenancePlansReducer from './maintenancePlans';

const rootReducer = combineReducers({
  form: formReducer,
  models: modelsReducer,
  configuration: configurationReducer,
  shifts: shiftsReducer,
  maintenancePlans: maintenancePlansReducer,
});

export default rootReducer;
